import React, { useState } from "react";

function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      question: "What is branding and why is it important for my business?",
      answer: "Branding is the process of creating a unique identity for your business through design, messaging, and strategy. It helps build trust, improves recognition, and makes your business stand out in a competitive market.",
    },
    {
      question: "What elements are included in a complete branding package?",
      answer: "A complete branding package usually includes logo design, color palette, typography, brand guidelines, and brand strategy. These elements ensure consistency across all platforms.",
    },
    {
      question: "How does branding help in business growth?",
      answer: "Strong branding attracts the right audience, builds customer loyalty, and increases perceived value. This ultimately leads to higher conversions and long-term growth.",
    },
    {
      question: "Can branding improve my online presence?",
      answer: "Yes, effective branding creates a consistent look and message across your website and social media, making your business more professional and trustworthy online.",
    },
    {
      question: "When should I consider rebranding my business?",
      answer: "You should consider rebranding if your current brand looks outdated, doesn’t reflect your business goals, or fails to connect with your target audience.",
    },

  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="k-faq-section">
      <div className="k-faq-container">
        <h2 className="k-faq-heading">Frequently Asked Questions</h2>

        {faqData.map((item, index) => (
          <div
            key={index}
            className={
              activeIndex === index ? "k-faq-box active" : "k-faq-box"
            }
          >
            <div
              className="k-faq-question"
              onClick={() => toggleFAQ(index)}
            >
              <span className="k-faq-title">{item.question}</span>
              <span className="k-faq-arrow">
                {activeIndex === index ? "▲" : "▼"}
              </span>
            </div>

            <div className="k-faq-answer">
              <p className="k-faq-text">{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default FAQ;